import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Component that handles Supabase invitation redirects and forwards to our password reset page
 */
const InvitationRedirect = () => {
  const [error, setError] = useState<string | null>(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Get all URL parameters
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get("token");
    const type = searchParams.get("type");

    console.log("Invitation redirect received:", {
      token: token ? `${token.substring(0, 10)}...` : null,
      type,
      fullPath: location.pathname + location.search,
    });

    // If we have the necessary token
    if (token) {
      // Redirect to our reset password page with the token
      const resetPath = `/admin/reset-password?token=${token}&type=${
        type || "invite"
      }`;
      console.log("Redirecting to:", resetPath);
      navigate(resetPath, { replace: true });
    } else {
      setError("Invalid invitation link. Missing token parameter.");
      console.error("Invalid invitation - no token in URL");
    }
  }, [location, navigate]);

  // Show loading or error
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        {error ? (
          <div className="text-destructive">
            <h2 className="text-xl font-bold">Error</h2>
            <p>{error}</p>
          </div>
        ) : (
          <div className="flex flex-col items-center gap-4">
            <div className="h-10 w-10 animate-spin rounded-full border-2 border-primary border-t-transparent" />
            <p>Processing invitation...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default InvitationRedirect;
